import { modelManager } from '@repo/ui';
import { preloadModelURL } from './secureRemoteFiles';

/**
 * Point the shared model preloader at this app's machine address rule, so it warms the exact URLs
 * the machines load: same store, token and refresh marker. Called once, at app start (`App.tsx`).
 */
export const installModelPreload = () => modelManager.setModelURLResolver(preloadModelURL);
